import api from './api';

export default {
  getFundersList(page, pageSize, orderby, search, terms, fields) {
    fields = { ...fields };

    let params = {
      paginate: pageSize,
      page,
      orderby,
      search,
      terms,
      fields
    };

    return new Promise((resolve, reject) => {
      api
        .get('product/search', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getFunder(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`product/find/${id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  update(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`product/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  updateBusiness(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`business/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  updateColour(id, colour) {
    return new Promise((resolve, reject) => {
      api
        .put(`colour/${id}`, {
          updates: { colour }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  register(funder) {
    const details = {
      business: {
        commercialName: funder.name,
        type: 'provider'
      },
      firstName: funder.user.firstName,
      lastName: funder.user.lastName,
      email: funder.user.email,
      phone: funder.user.phone,
      logo: funder.logo,
      address_1: funder.address_1,
      address_2: funder.address_2,
      address_3: funder.address_3,
      address_4: funder.address_4,
      address_5: funder.address_5,
      post_code: funder.post_code,
      product_name: funder.product.name,
      description: funder.product.description,
      product_type_id: funder.product.product_type_id,
      journey_id: funder.product.journey_id,
      traceable_url: funder.product.traceable_url,
      terms: funder.terms,
      bbb_id: funder.bbb_id
    };

    return new Promise((resolve, reject) => {
      api
        .post('register', { details })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  addAPI(updates) {
    return new Promise((resolve, reject) => {
      api
        .post(`business-api`, updates)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  updateAPI(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`business-api/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
